"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SessionFactory_1 = require("./SessionFactory");
class SessionClientFactory extends SessionFactory_1.SessionFactory {
    constructor(sessionRepo, langyan, cmdHub, evtHub) {
        super(false, sessionRepo, langyan, cmdHub, evtHub);
    }
    IsService() {
        return false;
    }
}
exports.SessionClientFactory = SessionClientFactory;
//# sourceMappingURL=SessionClientFactory.js.map